/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { PageTitle } from '../../../_metronic/layout/core';
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../../_metronic/partials/widgets';
import axios from 'axios';
import { Link } from 'react-router-dom';

const DashboardPage: FC = () => {
  const [contacts, setContacts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [landing, setLanding] = useState([]);

  useEffect(() => {
    axios.get('https://api.protechnologys.in/public/index.php/api/getContacts').then((response) => {
      setContacts(response.data);
    });
    axios
    .get('https://api.protechnologys.in/public/index.php/api/getLandingPage')
    .then((response) => {
      if (response.data.status) {
        setLanding(response.data.pages)
      }
    });
    axios
    .get('https://api.protechnologys.in/public/index.php/api/getTourDetails')
    .then((response) => {
      if (response.data.status) {
        setPackages(response.data.tours)
      }
    });
  }, []);

  return (
    <>
      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10 mt-6'>
        {/* begin::Col */}
        <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-md-5 mb-xl-10'>
          <Link to='/apps/user/enquiries'>
            <CardsWidget20
              className='h-md-90 mb-5 mb-xl-10'
              description='Active Enquiries'
              color='#0585c8'
              count={""+contacts.length}
              img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            />
          </Link>
          </div>

          <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-md-5 mb-xl-10'>
          <CardsWidget20
            className='h-md-90 mb-5 mb-xl-10'
            description='Total Destinations'
            color='rgb(200 149 5 / 72%)'
            count={""+landing.length}
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
          </div>
          <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-md-5 mb-xl-10'>
          <CardsWidget20
            className='h-md-90 mb-5 mb-xl-10'
            description='Total Packages'
            color='rgb(5 200 155)'
            count={""+packages.length}
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
          {/* <CardsWidget7
          className='h-md-50 mb-5 mb-xl-10'
          description='Professionals'
          icon={false}
          stats={357}
          labelColor='dark'
          textColor='gray-300'
        />*/}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          {/* <CardsWidget17 className='h-md-50 mb-5 mb-xl-10' />
        <ListsWidget26 className='h-lg-50' />*/}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xxl-6'>
          {/* <EngageWidget10 className='h-md-100' /> */}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row gx-5 gx-xl-10'>
        {/* begin::Col */}
        <div className='col-xxl-6 mb-5 mb-xl-10'>
          {/* <app-new-charts-widget8 cssclassName="h-xl-100" chartHeight="275px" [chartHeightNumber]="275"></app-new-charts-widget8> */}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xxl-6 mb-5 mb-xl-10'>
          {/* <app-cards-widget18 cssclassName="h-xl-100" image="./assets/media/stock/600x600/img-65.jpg"></app-cards-widget18> */}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}
    </>
  );
};

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };